module.exports = __webpack_public_path__ + "img/product_12.58ee35a.jpg";